import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
	confluence_availability_header: {
		id: 'product_search_dialog.confluence.confluence_availability_in_jira_search.header',
		defaultMessage: 'Your team is now using Confluence',
		description: 'Section title for indicating the user can join Confluence',
	},
	confluence_availability_description: {
		id: 'product_search_dialog.confluence.confluence_availability_in_jira_search.description',
		defaultMessage:
			'Your team is collaborating in Confluence. Organize team knowledge, capture ideas, and share requirements for your Jira projects with pages, whiteboards, and databases.',
		description: 'Description text for encouraging the user to join Confluence.',
	},
	confluence_availability_learn_more_button: {
		id: 'product_search_dialog.confluence.confluence_availability_in_jira_search.learn_more_button',
		defaultMessage: 'Learn more',
		description: 'Button to get more information about Confluence.',
	},
	confluence_availability_join_button: {
		id: 'product_search_dialog.confluence.confluence_availability_in_jira_search.join_button',
		defaultMessage: 'Join your team',
		description: 'Button to join Confluence.',
	},
	confluence_availability_tab_more_results: {
		id: 'product_search_dialog.confluence.confluence_availability_in_jira_search.tab.more_results',
		defaultMessage: 'More results',
		description: 'Lozenge text for indicating more results in the Confluence tab.',
	},
});
